import { SocialPostNotification } from "../interfaces/api/get-notifications";

/** Valores enviados por el BE como “vacío” que no deben mostrarse como preview real */
const PLACEHOLDER_PREVIEW_REGEXES: RegExp[] = [
  /^sin\s+texto\s+en\s+la\s+publicaci[oó]n\.?$/i,
  /^no\s+text\s+in\s+(the\s+)?post\.?$/i,
  /^sem\s+texto\s+na\s+publica[çc][aã]o\.?$/i,
];

function firstNonEmptyString(
  obj: Record<string, unknown>,
  keys: string[]
): string {
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === "string") {
      const t = v.trim();
      if (t) return t;
    }
  }
  return "";
}

export function stripSocialPostPreviewPlaceholders(text: string): string {
  const t = text.trim();
  if (!t) return "";
  if (PLACEHOLDER_PREVIEW_REGEXES.some((re) => re.test(t))) return "";
  return t;
}

export function normalizeSocialPostNotificationData(
  raw: Record<string, unknown>
): SocialPostNotification {
  const contentRaw = firstNonEmptyString(raw, [
    "content",
    "text",
    "caption",
    "message",
    "body",
  ]);
  const content = stripSocialPostPreviewPlaceholders(contentRaw);

  const imageUrl = firstNonEmptyString(raw, [
    "imageUrl",
    "thumbnailUrl",
    "thumbnail",
    "mediaUrl",
    "previewUrl",
    "image",
  ]);

  const socialRaw = firstNonEmptyString(raw, ["social", "socialProvider"]);
  const accountName = firstNonEmptyString(raw, [
    "accountName",
    "pageName",
    "account",
  ]);
  const postedAt = firstNonEmptyString(raw, ["postedAt", "publishedAt"]);

  return {
    social: socialRaw,
    status: typeof raw.status === "number" ? raw.status : Number(raw.status) || 0,
    content,
    ...(imageUrl ? { imageUrl } : {}),
    ...(accountName ? { accountName } : {}),
    ...(postedAt ? { postedAt } : {}),
  };
}
